import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { AddAlert, Button } from '../../../components'
import { verificarExisteEmpresaPdca } from '../base/redux/pdcaBaseActions'
import apiPdca from '../../../helpers/apiPdca'
import './integrationsTrelloCallback.scss'

export default () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { idProjetos } = useParams()

  const { sistema } = useSelector(state => state.layoutState)
  const nls = require(`./nls/${sistema.idioma}.json`)

  const [status, setStatus] = useState('loading')
  const [debugError, setDebugError] = useState('')

  useEffect(() => {
    const processar = async () => {
      try {
        const params = new URLSearchParams(window.location.search)
        const state = params.get('state')

        const hash = window.location.hash
        const token = new URLSearchParams(hash.replace('#', '')).get('token')

        if (!state || !token) {
          throw new Error('State ou token não encontrados no retorno do Trello.')
        }

        await apiPdca.post(`/projetos/${idProjetos}/integracao/trello/oauth/exchange`, {
          state,
          token
        })

        setStatus('success')
        //dispatch(AddAlert('success', nls.success || 'Integração com Trello realizada com sucesso'))
      } catch (error) {
        const mensagemTecnica =
          error?.response?.data?.complemento ||
          error?.response?.data?.title ||
          error?.message ||
          'Erro desconhecido ao processar callback do Trello.'

        setDebugError(mensagemTecnica)
        setStatus('error')
        //dispatch(AddAlert('danger', nls.error || 'Erro ao conectar com Trello'))
      }
    }

    processar()
  }, [dispatch, idProjetos, nls])

  const irParaIntegrationsComContexto = async () => {
    const result = await dispatch(verificarExisteEmpresaPdca(idProjetos))

    if (result?.ok) {
      history.push(`/myprojects/${idProjetos}/pdca/integrations`)
      return
    }

    history.push(`/myprojects/${idProjetos}/pdca`)
  }

  const handleVoltar = () => {
    irParaIntegrationsComContexto()
  }

  return (
    <div className='box-pdca-trello-callback-page'>
      <div className='box-pdca-trello-callback'>
        {status === 'loading' && (
          <div className='box-pdca-trello-callback-loading'>
            {nls.loading || 'Conectando com Trello...'}
          </div>
        )}

        {status === 'success' && (
          <div className='box-pdca-trello-callback-success'>
            <img src='/pdcaokacao.svg' alt='sucesso' />
            <div className='box-pdca-trello-callback-text'>
              {nls.success || 'Integração com Trello realizada com sucesso'}
            </div>

            <div className='box-pdca-trello-callback-actions'>
              <Button color='primary' onClick={handleVoltar}>
                {nls.back || 'Voltar para Integração'}
              </Button>
            </div>
          </div>
        )}

        {status === 'error' && (
          <div className='box-pdca-trello-callback-error'>
            <img src='/pdcaproblemaacao.svg' alt='erro' />
            <div className='box-pdca-trello-callback-text'>
              {nls.error || 'Erro ao conectar com Trello'}
            </div>

            {!!debugError && (
              <div className='box-pdca-trello-callback-debug'>
                {debugError}
              </div>
            )}

            <div className='box-pdca-trello-callback-actions'>
              <Button color='default' onClick={handleVoltar}>
                {nls.back || 'Voltar para Integração'}
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}